// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users_container_researchers__229Xp {
    display: flex;
    flex: 5 1;
    flex-direction: column;
    align-items: flex-start;
    align-content: baseline;
    justify-content: center;
    background-color: var(--hsrcBackgroundLight);
    border-radius: 1rem;
    padding: 2rem;
}

.users_container_users__u0\\+s5 {
    display: flex;
    flex: 5 1;
    flex-direction: column;
    align-items: flex-start;
    align-content: baseline;
    justify-content: center;
    background-color: var(--hsrcBackgroundLight);
    border-radius: 1rem;
    padding: 2rem;
}

.users_featuredItem__XoVef {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    cursor: default;
}

.users_featured__XjB8x {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.users_featuredTitleHeader__j2zXd {
    color: var(--hsrcDarkBlue);
    font-size: 15px;
    font-weight: bold;
}

.users_sidebarSubListItem__1\\+P-s {
    padding-left: 30px;
    cursor: pointer;
    display: flex;
    align-items:center;
    vertical-align: bottom;
    border-radius: 10px;
    margin-bottom: 25px;
}

.users_sidebarSubListItem__1\\+P-s.users_active__lL3WT,
.users_sidebarSubListItem__1\\+P-s:hover {
    /* background-color: rgb(240, 240, 255); */
}

.users_container_row__bipHR {
    display: flex;
    flex: 1 1;
    justify-content: space-between;
    flex-direction: column;
    align-content: center;
    align-items: center;
    align-self: center;
}

.users_printviewDialog__xBh43 {
    min-width: 90vw !important;
    max-width: 90vw !important;
}

.users_confirmDialogOverlay__H9ZBU {
    z-index: 10000;
    pointer-events: none;
}

.users_logicalErrorsDialog__VITiM {
    min-width: 35vw !important;
    max-width: 35vw !important;
    height: 90%;
}

.users_interactionDialog__eFRws {
    min-width: 40vw !important;
    max-width: 40vw !important;
    height: 90%;
}

.users_interactionHistoryDialog__GOqGR {
    min-width: 60vw !important;
    max-width: 60vw !important;
    min-height: 85%;
    max-height: 90%;
}

.users_addRespondentDialog__5jBl7 {
    min-width: 45vw !important;
    max-width: 45vw !important;
    min-height: 90%;
    max-height: 90%;
}

.users_editRespondentDialog__QWYuL {
    min-width: 45vw !important;
    max-width: 45vw !important;
    min-height: 90%;
    max-height: 90%;
}

.users_addResearcherDialog__rD2SR {
    min-width: 45vw !important;
    max-width: 45vw !important;
    min-height: 90%;
    max-height: 90%;
}

.users_editResearcherDialog__6rAuP {
    min-width: 45vw !important;
    max-width: 45vw !important;
    min-height: 90%;
    max-height: 90%;
}

.users_flex_row_container__zrj-Z {
    display: inline-flexbox;
    flex-direction: row;
    flex: 11 1;
    width: 100%;
    align-items: flex-start;
    align-content: center;
    justify-content: left;
}

.users_widget_container__gC-I3 {
    max-width: 40%;
    min-height: 40%;
    max-height: 50%;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/pages/Users/users.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAO;IACP,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAO;IACP,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,SAAO;IACP,8BAA8B;IAC9B,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,UAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB","sourcesContent":[".container_researchers {\r\n    display: flex;\r\n    flex: 5;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    align-content: baseline;\r\n    justify-content: center;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    border-radius: 1rem;\r\n    padding: 2rem;\r\n}\r\n\r\n.container_users {\r\n    display: flex;\r\n    flex: 5;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    align-content: baseline;\r\n    justify-content: center;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    border-radius: 1rem;\r\n    padding: 2rem;\r\n}\r\n\r\n.featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    cursor: default;\r\n}\r\n\r\n.featured {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.featuredTitleHeader {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n}\r\n\r\n.sidebarSubListItem {\r\n    padding-left: 30px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items:center;\r\n    vertical-align: bottom;\r\n    border-radius: 10px;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.sidebarSubListItem.active,\r\n.sidebarSubListItem:hover {\r\n    /* background-color: rgb(240, 240, 255); */\r\n}\r\n\r\n.container_row {\r\n    display: flex;\r\n    flex: 1;\r\n    justify-content: space-between;\r\n    flex-direction: column;\r\n    align-content: center;\r\n    align-items: center;\r\n    align-self: center;\r\n}\r\n\r\n.printviewDialog {\r\n    min-width: 90vw !important;\r\n    max-width: 90vw !important;\r\n}\r\n\r\n.confirmDialogOverlay {\r\n    z-index: 10000;\r\n    pointer-events: none;\r\n}\r\n\r\n.logicalErrorsDialog {\r\n    min-width: 35vw !important;\r\n    max-width: 35vw !important;\r\n    height: 90%;\r\n}\r\n\r\n.interactionDialog {\r\n    min-width: 40vw !important;\r\n    max-width: 40vw !important;\r\n    height: 90%;\r\n}\r\n\r\n.interactionHistoryDialog {\r\n    min-width: 60vw !important;\r\n    max-width: 60vw !important;\r\n    min-height: 85%;\r\n    max-height: 90%;\r\n}\r\n\r\n.addRespondentDialog {\r\n    min-width: 45vw !important;\r\n    max-width: 45vw !important;\r\n    min-height: 90%;\r\n    max-height: 90%;\r\n}\r\n\r\n.editRespondentDialog {\r\n    min-width: 45vw !important;\r\n    max-width: 45vw !important;\r\n    min-height: 90%;\r\n    max-height: 90%;\r\n}\r\n\r\n.addResearcherDialog {\r\n    min-width: 45vw !important;\r\n    max-width: 45vw !important;\r\n    min-height: 90%;\r\n    max-height: 90%;\r\n}\r\n\r\n.editResearcherDialog {\r\n    min-width: 45vw !important;\r\n    max-width: 45vw !important;\r\n    min-height: 90%;\r\n    max-height: 90%;\r\n}\r\n\r\n.flex_row_container {\r\n    display: inline-flexbox;\r\n    flex-direction: row;\r\n    flex: 11;\r\n    width: 100%;\r\n    align-items: flex-start;\r\n    align-content: center;\r\n    justify-content: left;\r\n}\r\n\r\n.widget_container {\r\n    max-width: 40%;\r\n    min-height: 40%;\r\n    max-height: 50%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_researchers": `users_container_researchers__229Xp`,
	"container_users": `users_container_users__u0+s5`,
	"featuredItem": `users_featuredItem__XoVef`,
	"featured": `users_featured__XjB8x`,
	"featuredTitleHeader": `users_featuredTitleHeader__j2zXd`,
	"sidebarSubListItem": `users_sidebarSubListItem__1+P-s`,
	"active": `users_active__lL3WT`,
	"container_row": `users_container_row__bipHR`,
	"printviewDialog": `users_printviewDialog__xBh43`,
	"confirmDialogOverlay": `users_confirmDialogOverlay__H9ZBU`,
	"logicalErrorsDialog": `users_logicalErrorsDialog__VITiM`,
	"interactionDialog": `users_interactionDialog__eFRws`,
	"interactionHistoryDialog": `users_interactionHistoryDialog__GOqGR`,
	"addRespondentDialog": `users_addRespondentDialog__5jBl7`,
	"editRespondentDialog": `users_editRespondentDialog__QWYuL`,
	"addResearcherDialog": `users_addResearcherDialog__rD2SR`,
	"editResearcherDialog": `users_editResearcherDialog__6rAuP`,
	"flex_row_container": `users_flex_row_container__zrj-Z`,
	"widget_container": `users_widget_container__gC-I3`
};
export default ___CSS_LOADER_EXPORT___;
